import * as React from "react";
import classnames from "classnames";
import Checkbox from "../components/Checkbox/CheckboxList/components/Checkbox/Checkbox.js";
/* empty css                  */
const CheckboxList = function({
  idPrefix,
  items,
  selectedItems,
  getItemIdentifier,
  renderItem,
  renderTrailingItem,
  onChange,
  isItemDisabled,
  checkboxAlignment = "top",
  className,
  itemClassName
}) {
  const handleChange = React.useCallback(
    ({ value, checked }) => {
      if (!onChange) {
        return;
      }
      const newValues = checked ? [...selectedItems, value] : selectedItems.filter((i) => getItemIdentifier(i) !== getItemIdentifier(value));
      onChange(newValues);
    },
    [selectedItems, getItemIdentifier, onChange]
  );
  return /* @__PURE__ */ React.createElement("fieldset", { className: classnames("checkbox-list", className) }, items.map((item) => {
    const id = idPrefix + String(getItemIdentifier(item));
    const isSelected = selectedItems.some(
      (i) => getItemIdentifier(i) === getItemIdentifier(item)
    );
    const isDisabled = isItemDisabled?.(item);
    const trailingMarkup = renderTrailingItem?.(item);
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        key: id,
        className: classnames("checkbox-list__item", itemClassName),
        "data-t": "checkbox-list-item"
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: `checkbox-list__item-checkbox checkbox-list__item-checkbox--${checkboxAlignment}`
        },
        /* @__PURE__ */ React.createElement(
          Checkbox,
          {
            id,
            value: item,
            checked: isSelected,
            disabled: isDisabled,
            onChange: handleChange
          }
        )
      ),
      /* @__PURE__ */ React.createElement("div", { className: "checkbox-list__item-content" }, /* @__PURE__ */ React.createElement("label", { className: "checkbox-list__item-label", htmlFor: id }, renderItem(item)), trailingMarkup && /* @__PURE__ */ React.createElement("span", { className: "checkbox-list__item-trailing" }, trailingMarkup))
    );
  }));
};
export {
  CheckboxList as default
};
//# sourceMappingURL=CheckboxList.js.map
